import React from 'react';
import { useWizard } from './WizardContext';
import { Table } from "react-bootstrap";
import LanguageToggle from "../LanguageToggle";
import { useGuestContext } from "../../../../contexts/GuestContext";
import cuteMonk1 from "../../../../assets/img/baolinPrivate/cute_monk1.png";
import cuteMonk2 from "../../../../assets/img/baolinPrivate/cute_monk2.png";
const Step3 = React.forwardRef((props, ref) => {
  const {
    firstname, setFirstname,
    lastname, setLastname,
    chinesename, setChinesename,
    email, setEmail,
    phone, setPhone,
    s8_9_9_30, setS8_9_9_30,
    s8_9_13_30, setS8_9_13_30,
    s15_9_9_30, setS15_9_9_30,
    s22_9_9_30, setS22_9_9_30,
    s29_9_9_30, setS29_9_9_30,
    s6_10_9_30, setS6_10_9_30,
    s13_10_9_30, setS13_10_9_30,
    s20_10_9_30, setS20_10_9_30,
    s27_10_9_30, setS27_10_9_30,
    s27_10_13_30, setS27_10_13_30
  } = useWizard();
  const { language } = useGuestContext();
  const isValidated = () => {
    return true;
  };

  React.useImperativeHandle(ref, () => ({
    isValidated: () => {
      return isValidated();
    },
  }));

  const getSessionDates = () => {
    const sessions = [];

    if (s8_9_9_30) sessions.push("8/9 9:30");
    if (s8_9_13_30) sessions.push("8/9 13:30");
    if (s15_9_9_30) sessions.push("15/9 9:30");
    if (s22_9_9_30) sessions.push("22/9 9:30");
    if (s29_9_9_30) sessions.push("29/9 9:30");
    if (s6_10_9_30) sessions.push("6/10 9:30");
    if (s13_10_9_30) sessions.push("13/10 9:30");
    if (s20_10_9_30) sessions.push("20/10 9:30");
    if (s27_10_9_30) sessions.push("27/10 9:30");
    if (s27_10_13_30) sessions.push("27/10 13:30");

    return sessions.join(", ");
  };

  const getDisplayTextForSelectionOption = () => {

    return language === "English" ? '2024 Liang Huang Jeweled Repentance Weekly Sunday Service' : '2024梁皇寶懺精進共修';
  };

  const getDisplayTrueOrFalse = (option) => {
    return language === "English" ? (option ? "Yes" : "No") : (option ? "是" : "否");
  };

  return (
    <div className="wizard-step">
      <p className="text-center mb-2 font-weight-bold">
        <img src={cuteMonk1} alt="Company Logo" width="40" className="mr-3" />
        {language === "English" ? "Confirm your details" : "請確認所填信息無誤"}
        <img src={cuteMonk2} alt="Company Logo" width="40" className="ml-3" />
      </p>

      <hr />
      <LanguageToggle />
      <hr />
      <Table striped hover>
        <thead>
          <tr>
            <th>{language === "English" ? "Item" : "項目"}</th>
            <th className='d-flex justify-content-center align-items-center'>{language === "English" ? "Information" : "資料"}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{language === "English" ? "Event Name" : "法會名稱"}</td>
            <td className='d-flex justify-content-center text-center'>{getDisplayTextForSelectionOption()}</td>
          </tr>
          <tr>
            <td>{language === "English" ? "Full English Name" : "英文全名"}</td>
            <td className='d-flex justify-content-center text-center'>{firstname + " " + lastname}</td>
          </tr>
          <tr>
            <td>{language === "English" ? "Chinese Name" : "中文姓名"}</td>
            <td className='d-flex justify-content-center text-center'>{chinesename ? chinesename : (language === "English" ? "Not Provided" : "未填寫")}</td>
          </tr>
          <tr>
            <td>{language === "English" ? "Email Address" : "郵箱地址"}</td>
            <td className='d-flex justify-content-center text-center'>{email}</td>
          </tr>
          <tr>
            <td>{language === "English" ? "Contact Phone" : "聯繫電話"}</td>
            <td className='d-flex justify-content-center text-center'>{phone}</td>
          </tr>

          <tr>
            <td>{language === "English" ? "Registered Sessions" : "共修日期"}</td>
            <td className='d-flex justify-content-center text-center'>
              {getSessionDates()}
            </td>
          </tr>

        </tbody>
      </Table>
    </div>
  );
});

export default Step3;
